import styles from "./Footer.module.sass";
import Icon from "colbi_web_ui/lib/components/Icon/Icon";
import LoginFolderConfigs from "./utils";

const Footer = () => {
    const { footerText } = LoginFolderConfigs;
    return (
        <div className={styles["container"]}>
            <Icon
                className={styles["footer-img"]}
                name="sovos-logo"
                style={{ width: 130, height: 30 }}
            />
            <p>{footerText}</p>
        </div>
    );
};

export default Footer;
